import { getTimeCardTaggedTime } from '@lib/api'
import { taggedTimeKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useTaggedTime = (timeCardId = 0) => {
  return useQuery(
    taggedTimeKeys.getTimeCardTaggedTime(timeCardId),
    () => getTimeCardTaggedTime(timeCardId),
    { enabled: timeCardId !== 0 },
  )
}
